'use strict';

var ipRegex = require('ip-regex');
var isIp = function isIp(string) {
  return ipRegex({
    exact: true
  }).test(string);
};
isIp.v4 = function (string) {
  return ipRegex.v4({
    exact: true
  }).test(string);
};
isIp.v6 = function (string) {
  return ipRegex.v6({
    exact: true
  }).test(string);
};
isIp.version = function (string) {
  return isIp(string) ? isIp.v4(string) ? 4 : 6 : undefined;
};
module.exports = isIp;